<div class="form-group">
  <label class="col-md-2 control-label">Compañía:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Seleccione</mat-label>
      <mat-select matSelect [(ngModel)]="modelFilter.idCompania" [disabled]="listaCompanias.length == 1"
        (selectionChange)="companiaChanged()">
        <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
          {{ company.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <label class="col-md-2 control-label">Sede:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Seleccione</mat-label>
      <mat-select matSelect [(ngModel)]="modelFilter.sedes" name="sedes" multiple>
        <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="form-group">
  <label class="col-md-2 control-label">Trabajador:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Nombres y Apellidos </mat-label>
      <input matInput type="text" [(ngModel)]="modelFilter.nombreEmpleado" name="nombreEmpleado" maxlength="40" />
    </mat-form-field>
  </div>

  <label class="col-md-2 control-label">Nro Documento Identidad:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label>Nro Documento Identidad</mat-label>
      <input matInput type="text" [(ngModel)]="modelFilter.nroDocumento" name="nroDocumento" maxlength="15"
        (keypress)="keyPressNumberOnly($event)" />
    </mat-form-field>
  </div>
</div>
<div class="form-group">
  <label class="col-md-2 control-label">Código Solicitud:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Código Solicitud </mat-label>
      <input matInput type="text" [(ngModel)]="modelFilter.codigoSolicitud" name="codigoSolicitud" maxlength="10" />
    </mat-form-field>
  </div>

  <label class="col-md-2 control-label">Solicitante:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Solicitante </mat-label>
      <input matInput type="text" placeholder="Solicitante" [(ngModel)]="modelFilter.solicitante" name="solicitante"
        maxlength="40" />
    </mat-form-field>
  </div>
</div>

<div class="form-group">
  <label class="col-md-2 control-label">Empresa:</label>
  <div class="col-md-4">
    <mat-form-field appearance="outline">
      <mat-label> Empresa </mat-label>
      <input matInput type="text" [(ngModel)]="modelFilter.nombreContratista" name="nombreContratista"
        maxlength="40" />
    </mat-form-field>
  </div>
  <ng-container *ngIf="displayFechaAprobacion">
    <label class="col-md-2 control-label">Fecha Aprobación Documentos:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de Aprobación</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Desde" [(ngModel)]="modelFilter.fechaInicioAprobacion" />
          <input matEndDate placeholder="Hasta" [(ngModel)]="modelFilter.fechaFinAprobacion" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="displayFechaInduccion">
    <label class="col-md-2 control-label">Fecha de Inducción:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de Inducción</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Desde" [(ngModel)]="modelFilter.fechaInicioInduccion" />
          <input matEndDate placeholder="Hasta" [(ngModel)]="modelFilter.fechaFinInduccion" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </ng-container>
</div>